import React from "react";
import './GlobalResponsibilitySection.css';  // Import the external CSS file

const GlobalResponsibilitySection = () => {
  return (
    <div className="global-responsibility-section">
      {/* Main Heading: Who We Are */}
      <h1>Who We Are</h1>
      <p  style={{
            fontSize: "1.1rem",

            lineHeight: "1.7",
            textAlign:"center"
          }}>
        Maniraj Builder is a trusted name in the real estate and construction industry, specializing in residential and commercial projects in Dhanbad, Jharkhand.
        With a strong commitment to quality, innovation, and affordability, we strive to create modern living spaces that cater to the needs of individuals and businesses alike.
      </p>

      {/* Flex container for the left and right sections */}
      <div className="content-wrapper">
        {/* Left Section: Our Mission */}
        <div className="section">
          <h1>Our Mission</h1>
          <p style={{
            fontSize: "1.1rem",

            lineHeight: "1.7"
          }}>
            Our mission is to provide affordable, well-equipped, and high-quality housing solutions to people from all walks of life.
            We believe that everyone deserves a home that is not only economical but also enriched with modern amenities and comfort.
          </p>
        </div>

        {/* Right Section: Our Projects */}
        <div className="section">
          <h1>Our Projects</h1>
          <p>
            Maniraj Builder is a leading residential and commercial construction company based in Dhanbad, Jharkhand, committed to delivering high-quality housing and commercial projects.
          </p>
          <ul className="custom-bullet-list">
            <li><strong>Completed Projects:</strong> Successfully delivered "Maniraj Ghrih," a well-planned residential project located in Nawadih, Hirak Road, Dhanbad.</li>
            <li><strong>Ongoing Development:</strong> Currently developing "Maniraj Aalay," a residential and commercial project near the Survey Office, Dhanbad, featuring well-designed commercial spaces, including shops.</li>
            <li><strong>Future Expansion:</strong> With a vision to provide affordable housing equipped with modern amenities, the company is set to launch new projects in the near future.</li>
          </ul>
        </div>
        <div className="section">
          <h1>Our Visionary Leader
</h1>
        </div>


      </div>
    </div>
  );
};

export default GlobalResponsibilitySection;
